import {Component, NgZone, OnInit, ViewChild} from '@angular/core';
import {PickupPointFee} from "./pickup-point.fee";
import {PickupPointFeeService} from "../pickup-point-fee.service";
import {SaraSelectorService} from "../../../shared/sara-selector/sara-selector.service";
import {ItemSelector} from "../../../shared/sara-selector/item-selector";
import {PointOfSaleA2Service} from "../../../core/point-of-sale.service.service";
import {AdditionalPickupPointService} from "../../../core/additional-pickup-point.service";
import {EvaButton} from "../../../shared/eva-button/eva-button";
import {ActivatedRoute, Router} from "@angular/router";
import {NotificationService} from "../../../root/toast/notification.service";
import {ModalService} from "../../../root/modal/modal.service";
import {LoadingWheelService} from "../../../root/loading/loading-wheel.service";
import {FormBuilder, Validators} from "@angular/forms";
import {SessionService} from "../../../core/session.service";
import {ErrorMessage} from "../../../shared/sara-input/error-message";
import {SidebarService} from "../../../root/sidebar/sidebar.service";
import {Observable} from "rxjs/Observable";
import {TranslateService} from '@ngx-translate/core';
import {langs,langsForSelect} from "../../../shared/constants/constants";

@Component({
    selector: 'pickup-point-fee-edit',
    templateUrl: './pickup-point-fee-edit.component.html',
    providers: [PickupPointFeeService, SaraSelectorService, PointOfSaleA2Service, AdditionalPickupPointService]
})
export class PickupPointFeeEditComponent implements OnInit{

    errors:any;
    fee:PickupPointFee = new PickupPointFee();
    data: any;
    hasPermissionToCreateFeeIdentifier: boolean = false;
    langsForSelect = langsForSelect;
    feeIdentifierOid: number = null;
    feeIdentifierLangId: number = null;
    filteredFeeIdentifiersByLang: any[] = null;
    showCreateFeeIdentifier: boolean = false;
    creatingFeeIdentifier: boolean = false;
    newFeeIdentifierNamesByLang = {
        ES: null,
        EN: null,
        PT: null
    };
    savingPickupPointFee: boolean = false;
    posSelector:ItemSelector;
    posAddSelector:ItemSelector;
    createFeeIdentifiersButton:EvaButton;
    cancelButton:EvaButton;
    saveButton:EvaButton;
    savingButton:EvaButton;
    companyOid: number;
    id: string;
    @ViewChild('feeForm') form;
    private errorMessages = {
        'identifierOid': 'common.error.REQUIRED',
        'feeAmount': 'warning.invalidNumberFormat',
        'feeSelector': 'common.error.REQUIRED'
    }
    currency:string;
    constructor(private pupFeeService:PickupPointFeeService, private selector: SaraSelectorService,
                private  zone: NgZone, private posService: PointOfSaleA2Service,
                private addPointService: AdditionalPickupPointService, private route: ActivatedRoute,
                private toast:NotificationService, private navigation:Router, private modalService:ModalService,
                private loading:LoadingWheelService, private _fb: FormBuilder, private session:SessionService,
                private sidebar: SidebarService, private translator:TranslateService) {
        this.createFeeIdentifiersButton = new EvaButton('fees.FEEIDENTIFIER.create', '-primary', '-md');
        this.cancelButton = new EvaButton('common.CANCEL', '-link', '-md');
        this.saveButton = new EvaButton('common.SAVE', '-primary', '-md');
        this.savingButton = new EvaButton('common.LOADING', '-primary', '-md');
        this.sidebar.sidebar = "generalConditions";
    }


    private getPickupSelectorConfig(pointsOfSale, selectedPos, listTitle, selectedItemsTitle, idGenerator?:Function) {
        var nameGenerator =  (pos) => {return pos.name;};

        var poss= this.selector.getItemsForSelector(pointsOfSale, selectedPos, nameGenerator, idGenerator);

        return this.selector.newItemSelectorBuilder()
            .withListOfItemsTitle(listTitle)
            .withListOfSelectedItemsTitle(selectedItemsTitle)
            .withItems(poss)
            .build();
    }

    save(){
        this.fee.pickupPointOids = [];
        this.fee.pickupPointOids = this.fee.pickupPointOids.concat(this.posSelector.getSelectedItemsOid()).concat(this.posAddSelector.getSelectedItemsOid());
        this.bindForm();
        if(this.form.valid){
            this.zone.run(() => {
                this.savingPickupPointFee = true;
                this.setIdentifierObject();
                if(this.id=='add'){
                    this.saveFee();
                }else{
                    this.updateFee();
                }
            });
        }else{
            this.showErrors();
        }
    }

    amountTypeChange(){
        if (this.fee.amountType == 'PERCENTAGE') {
            this.fee.paymentType = 'UNIQUE';
        }
    }

    cancel(){
        this.modalService.show("CANCEL_ALERT_TITLE", "CANCEL_ALERT_DESCRIPTION",
            () => this.navigation.navigateByUrl('/company/'+this.companyOid+'/pickupPointFee'));
    }

    getCurrencyCode(){
        if(!!this.session.getUserSession()){
            return this.session.getUserSession().currencyCode;
        }
    }

    ngOnInit() {
        this.loading.show();
        this.buildForm();
        this.errors = {};
        this.hasPermissionToCreateFeeIdentifier = this.session.loggedUserAllowed('PERM_FEE_IDENTIFIER_CREATE');
        this.route.params.subscribe(params => {
            this.companyOid = params['companyId'];
            this.id = params['id'];
            let hasFeeId = this.id=='add'?false:true;
            if(hasFeeId){
                this.pupFeeService.getOne(this.companyOid, this.id).subscribe(result => {
                    // name kept for showing the old (no longer used) name, replaced with identifier
                    this.fee.name = result.name; 
                    this.fee.category = result.category;
                    this.fee.paymentType = result.paymentType;
                    this.fee.amount = result.amount;
                    this.fee.amountType = result.amountType;
                    this.fee.origin = result.origin;
                    this.fee.identifier = result.identifier || null;
                    this.fee.pickupPointOids = result.pickupPointOids;
                    this.getData(result.pickupPointOids);
                })
            }else{
                this.getData([]);
            }
        });
    }

    private getData(oids: number[]){
        let context = this;
        this.zone.run(() => {
            this.pupFeeService.getData(this.companyOid).subscribe(result => {
                this.data = {
                    categories: result[2],
                    types: result[1],
                    paymentTypes: result[3],
                    origins: result[0],
                    feeIdentifiers: result[4]
                };
                context.loading.hide();
                this.selectFeeIdentifierAndLang();
            });

            this.posService.get(this.companyOid).subscribe(result => {
                this.posSelector = this.getPickupSelectorConfig(result, oids, "fees.posSelector.listOfItemsTitle", "fees.posSelector.listOfSelectedItemsTitle",
                    (obj) => {
                        return obj.officePoint.oid
                    });
                context.loading.hide();
            });

            this.addPointService.get(this.companyOid).subscribe(result => {
                this.posAddSelector = this.getPickupSelectorConfig(result, oids, "fees.pickupSelector.listOfItemsTitle", "fees.pickupSelector.listOfSelectedItemsTitle");
                context.loading.hide();
            });

        });
    }

    changeFeeIdentifierLang(selectedLangId: any) {
        if (!selectedLangId) return;
        this.feeIdentifierOid = null;
        this.form.controls['identifierOid'].reset();
        const selectedLang = this.langsForSelect.find(lang => lang.id === selectedLangId);
        this.filterFeeIdentifiersByLang(selectedLang.lang);
    }

    filterFeeIdentifiersByLang(langStr: string) {
        if (!this.data) return;
        this.filteredFeeIdentifiersByLang = this.data.feeIdentifiers.filter(identifier => identifier.lang === langStr);
    }

    selectFeeIdentifierAndLang() {
        if (!!this.fee.identifier && !!this.fee.identifier.oid) {
            this.feeIdentifierLangId = this.getIdForLang(this.fee.identifier.lang);
            this.filterFeeIdentifiersByLang(this.fee.identifier.lang);
        } else {
            // default to app lang
            const appLang = (!!this.translator.currentLang ? this.translator.currentLang.toUpperCase() : null) || 'ES';
            this.feeIdentifierLangId = this.getIdForLang(appLang);
            this.filterFeeIdentifiersByLang(appLang);
        }
        // feeIdentifierLangId model change fires the reset of feeIdentifierOid so for the 1st asignment we waint until after the view renders
        setTimeout(() => {
            this.feeIdentifierOid = (!!this.fee.identifier && !!this.fee.identifier.oid) ? this.fee.identifier.oid : null;
        }, 0);
    }

    getIdForLang(langStr: string): number {
        if (!langStr) return;
        const langObj = this.langsForSelect.find(langObj => langObj.lang === langStr);
        return langObj.id || 0;
    }

    getLangNameForId(langId: number) {
        if (!langId) return;
        const langObj = this.langsForSelect.find(lang => lang.id === langId);
        return langObj.lang || 'ES';
    }

    createFeeIdentifiers() {
        if (!this.hasPermissionToCreateFeeIdentifier) return;
        if (!!this.newFeeIdentifierNamesByLang.ES && !!this.newFeeIdentifierNamesByLang.EN && !!this.newFeeIdentifierNamesByLang.PT) {
            this.creatingFeeIdentifier = true;
            const identifiersAllLangs = langs.map((lang) => { return { lang, name: this.newFeeIdentifierNamesByLang[lang] } } );
            this.pupFeeService.createFeeIdentifiers(identifiersAllLangs).subscribe(
                _ => { 
                    this.reloadFeeIdentifiers(); 
                    this.newFeeIdentifierNamesByLang.ES = '';
                    this.newFeeIdentifierNamesByLang.EN = '';
                    this.newFeeIdentifierNamesByLang.PT = '';
                },
                _ => { this.creatingFeeIdentifier = false; }, // request errors are handled elsewhere
                _ => { this.creatingFeeIdentifier = false; },
            );
        }
    }

    reloadFeeIdentifiers() {
        this.pupFeeService.getFeeIdentifiers().subscribe(
            identifiers => { 
                this.data.feeIdentifiers = identifiers;
                const lang = this.getLangNameForId(this.feeIdentifierLangId);
                this.filterFeeIdentifiersByLang(lang);
            }
        );
    }

    // the selector set only the IDs, this function sets the identifier object in the fee
    setIdentifierObject() {
        const identifierObject = this.data.feeIdentifiers.find(fi => fi.id === this.feeIdentifierOid);
        if (!!identifierObject) {
            this.fee.identifier = JSON.parse(JSON.stringify(identifierObject));
            delete this.fee.identifier.value; // delete value from copy because is only needed for selects
            delete this.fee.identifier.id; // delete id from copy because is only needed for selects
        }
    }

    private buildForm() {
        this.form = this._fb.group({
            identifierOid: ['', [Validators.required]],
            feeAmount: ['', [Validators.required, Validators.pattern(/^[0-9]{1,3}((,|\.)[0-9]{1})?$/), this.pupFeeService.positiveValueWrapper]],
            feeSelector: ['', this.pupFeeService.notEmptyListWrapper]
        });
    }

    private bindForm(){
        this.form.controls['identifierOid'].setValue(this.feeIdentifierOid);
        this.form.controls['feeSelector'].setValue(this.fee.pickupPointOids);
        this.form.controls['feeAmount'].setValue(this.fee.amount);
    }

    private showErrors() {
        this.errors = {};
        for(var i in this.form.controls){
            if(!this.form.controls[i].valid){
                this.errors[i] = new ErrorMessage('-invalid', this.errorMessages[i]);
                window.scrollTo(0,0);
            }
        }
    }

    private saveFee() {
        let context = this;
        this.pupFeeService.save(this.fee, this.companyOid).subscribe((result) => {
            this.persistCallback(context);
        }, (err) => {
            this.savingPickupPointFee = false;
            Observable.throw(err);
            throw err;
        }, () => { this.savingPickupPointFee = false; })
    }

    private persistCallback(context:any){
        context.toast.displayToast('fees.TITLE','fees.confirmationMessage.SUCCESS_SAVE', null, 'INFO');
        context.navigation.navigateByUrl('/company/'+context.companyOid+'/pickupPointFee');
    }

    showActionButtons(){
        return this.session.loggedUserAllowed('PERM_FEE_EDIT') ||
            this.session.loggedUserAllowed('PERM_FEE_DELETE');
    };

    private updateFee() {
        let context = this;
        this.pupFeeService.update(this.fee, this.companyOid, this.id).subscribe((result) => {
            this.persistCallback(context);
        }, 
        () => { this.savingPickupPointFee = false; },
        () => { this.savingPickupPointFee = false; } )
    }
}


// WEBPACK FOOTER //
// ./public/upgrade/feature/pickuppointfee/edit/pickup-point-fee-edit.component.ts